import z from 'zod';

export const nonEmptyArray = <T extends z.ZodType>(schema: T) => z.tuple([schema], schema);
